import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend, Label,
    Modal, ModalHeader, ModalBody, Table
} from "reactstrap"
import { accessRole } from '../../../../../../helpers/access_role'
import { Preview } from '../../../../../../helpers/ui/FileInput'

import { Link, Redirect } from "react-router-dom"
import apiResponse from '../../../../../../services/apiResponse'

import { cancelToken } from "../../../../../../services/adapters/kepegawaian/diklatService"
// import PegawaiSideBar from '../../GlobalComponents/PegawaiSidebar'

import UpdateBloc from '../Update/Blocs/UpdateBloc'
import IndexBloc from '../Index/Blocs/DiklatBloc'

const urlParams = new URLSearchParams(window.location.search);
const uuid = urlParams.get('uuid');
const typename = 'Struktural';

class DetailView extends Component {
    // Retrieve Data Pegawai by Admin / Pegawai
    userdata = JSON.parse(localStorage.getItem('userdata'));
    employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'));
    peg_uuid = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_uuid : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted.employee_uuid : "")


    source
    indexBloc = new IndexBloc()
    updateBloc = new UpdateBloc()

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            detail: [],
            trainingOption: [],
            modal: false,
            trainingFilter: {
                            filter_value: "",
                            page_number: 1,
                            page_size: 50,
                            sort_order: {
                                column: 'training_type_sort',
                                order: 'asc' 
                            }
                        },
            hoursDetail: {},
            peg_uuid: ''
        }
    }

    toggleModal = () => {
        this.setState({ modal: !this.state.modal })
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                training_uuid: this.props.uuid,
                training_employee_uuid: this.state.peg_uuid,
                training_type: this.props.type,
                ...values
            },
            confirm: true
        })
    }

    loadTraining = async () => {
        let offset = (this.state.trainingFilter.page_number-1)*this.state.trainingFilter.page_size
        const query = {
            type: typename,
            search: this.state.trainingFilter.filter_value,
            limit: this.state.trainingFilter.page_size,
            offset: offset,
            order: this.state.trainingFilter.sort_order.column,
            sort: this.state.trainingFilter.sort_order.order,
            status: 1
        }
        await this.updateBloc.fetchTrainingList(query, this.source.token)
    }

    loadDetail = async () => {
        const query = {
            uuid: uuid
        }
        await this.updateBloc.fetchDetail(query, this.source.token)
    }

    submitData = async () => {
        await this.updateBloc.fetchUpdate(this.state.dataForm)
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    loadHours = async () => {
        const query = {
            uuid: uuid,
            employee_uuid: this.state.peg_uuid
        }
        await this.indexBloc.fetchHours(query, this.source.token)
    }


    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadTraining()
        this.loadDetail()
        // this.loadHours()
    }

    componentDidMount() {
        this.setTokenAPI()

        this.indexBloc.hoursChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ 
                        hoursDetail: result.data.response
                    })
                    break;
                default:
                    break;
            }
        })

        this.updateBloc.trainingListChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        trainingOption: result.data.response.result
                    })
                    break;
            
                default:
                    break;
            }
        })

        this.updateBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ 
                        detail: result.data.response, 
                        peg_uuid: result.data.response.training_employee_uuid, 
                    })
                    this.loadHours()
                    break;
                default: 
                    break;
            }
        })

        this.updateBloc.updateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

    }

    componentWillUnmount() {
        this.updateBloc.detailChannel?.unsubscribe()
        this.updateBloc.updateChannel?.unsubscribe()
        this.updateBloc.trainingListChannel?.unsubscribe()
    }

    render() {
        const { type } = this.props
        const { result, detail } = this.state.detail
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">
                            {/* <PegawaiSideBar active={`diklat&type=${type}`} /> */}

                            <Card className="pegawai-rightbar">
                                <CardBody>
                                    <div className="float-end">
                                        <Link to={`?index`}>
                                            <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                        </Link>
                                    </div>
                                    <CardTitle>Detail Diklat {typename}</CardTitle>    
                                    <hr />
                                        <Row className="mb-2">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Nama Diklat 
                                            </Label>
                                            <Label
                                                className="col-md-6 col-form-label"
                                            >
                                                {result?.training_type_name}
                                            </Label>
                                        </Row>
                                        <Row className="mb-2">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Luar / Dalam Negeri
                                            </Label>
                                            <Label
                                                className="col-md-6 col-form-label"
                                            >
                                                {detail?.training_domicile ? 'Luar Negeri' : 'Dalam Negeri'}
                                            </Label>
                                        </Row>
                                        { detail?.training_domicile === 0 ?
                                            <Fragment>
                                                <Row className="mb-2">
                                                    <Label
                                                        className="col-md-2 col-form-label"
                                                    >
                                                        Provinsi
                                                    </Label>
                                                    <Label
                                                        className="col-md-6 col-form-label"
                                                    >
                                                        {result?.training_province_name}
                                                    </Label>
                                                </Row>
                                                <Row className="mb-2">
                                                    <Label
                                                        className="col-md-2 col-form-label"
                                                    >
                                                        Kota
                                                    </Label>
                                                    <Label
                                                        className="col-md-6 col-form-label"
                                                    >
                                                        {result?.training_city_name}
                                                    </Label>
                                                </Row>
                                            </Fragment>
                                            :
                                            <Fragment>
                                                <Row className="mb-2">
                                                    <Label
                                                        className="col-md-2 col-form-label"
                                                    >
                                                        Negara
                                                    </Label>
                                                    <Label
                                                        className="col-md-6 col-form-label"
                                                    >
                                                        {result?.training_country_name}
                                                    </Label>
                                                </Row>
                                                <Row className="mb-2">
                                                    <Label
                                                        className="col-md-2 col-form-label"
                                                    >
                                                        Kota
                                                    </Label>
                                                    <Label
                                                        className="col-md-6 col-form-label"
                                                    >
                                                        {result?.training_city_text}
                                                    </Label>
                                                </Row>
                                            </Fragment>
                                        }
                                        <Row className="mb-2">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Penyelenggara 
                                            </Label>
                                            <Label
                                                className="col-md-6 col-form-label"
                                            >
                                                {result?.training_organizer}
                                            </Label>
                                        </Row>
                                        <Row className="mb-2">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Angkatan 
                                            </Label>
                                            <Label
                                                className="col-md-6 col-form-label"
                                            >
                                                {result?.training_generation}
                                            </Label>
                                        </Row>
                                        <Row className="mb-2">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Tahun 
                                            </Label>
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                {result?.training_year}
                                            </Label>
                                        </Row>
                                        <Row className="mb-2">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggal Mulai 
                                            </Label>
                                            <Label
                                                className="col-md-3 col-form-label"
                                            >
                                                {result?.training_start_date}
                                            </Label>
                                        </Row>
                                        <Row className="mb-2">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggal Selesai 
                                            </Label>
                                            <Label
                                                className="col-md-3 col-form-label"
                                            >
                                                {result?.training_end_date}
                                            </Label>
                                        </Row>
                                        <Row className="mb-2">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                No STTP 
                                            </Label>
                                            <Label
                                                className="col-md-5 col-form-label"
                                            >
                                                {result?.training_sttpp_number}
                                            </Label>
                                        </Row>
                                        <Row className="mb-2">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggal STTP 
                                            </Label>
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                {result?.training_sttpp_date}
                                            </Label>
                                        </Row>
                                        <Row>
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Jumlah Jam 
                                            </Label>
                                            <Label
                                                className="col-md-3 col-form-label"
                                            >
                                                {result?.training_number_of_hours}
                                            </Label>
                                        </Row>
                                        <Row className="mb-2">
                                            {this.state.hoursDetail &&
                                                <>
                                                    <Label className="col-md-2 col-form-label"></Label>
                                                    <Label className="col-md-6 col-form-label">
                                                        <span className="text-danger" style={{ fontSize: '12px' }} >Note: Jumlah jam diklat anda tahun ini telah mencapai {this.state.hoursDetail?.total_hours} jam. <a href="javascript:void(0)" onClick={() => this.toggleModal() }>Lihat Detail</a></span>
                                                    </Label>
                                                </>
                                            }
                                        </Row>
                                        <Row className="mb-2">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                File Pendukung
                                            </Label>
                                            <Label
                                                className="col-md-6 col-form-label"
                                            >
                                                <Preview value={detail?.document} />
                                            </Label>
                                        </Row>
                                </CardBody>    
                            </Card>    
                        </Col>
                    </Row> 
                </Container> 
                <Modal isOpen={this.state.modal} toggle={() => this.toggleModal()} size="lg">
                    <ModalHeader toggle={() => this.toggleModal()}>Keterangan Jam Diklat</ModalHeader>
                    <ModalBody>
                        <Table>
                            <thead>
                                <tr>
                                    <th>No</th>
                                    <th>Diklat</th>
                                    <th>Jam Diklat</th>
                                </tr>
                            </thead>
                            <tbody>
                                { this.state.hoursDetail.diklat?.map((value, index) => {
                                    return (
                                        <Fragment>
                                            <tr>
                                                <th>{index + 1}</th>
                                                <th>{value.training_type.training_type_name}, {value.training_type.training_type_description}</th>
                                                <th>{value.training_number_of_hours}</th>
                                            </tr>
                                        </Fragment>
                                    )
                                }) }
                            </tbody>
                        </Table>
                    </ModalBody>
                </Modal>
            </Fragment>
        )
    }
}

export default DetailView
